export default __webpack_public_path__ + "static/media/trr-event-trivia.8fd10573.png";